import { $, $$ } from '../utils/query-selector.js'
const testimonials = $$('.js-testimonials')

if (testimonials.length) {
  (async function () {
    const { default: Flickity } = await import(/* webpackChunkName: "flickity" */ 'flickity')

    for (const el of testimonials) {
      /* eslint-disable-next-line no-new */
      new Flickity($('.js-testimonials__carousel', el), {
        arrowShape: 'M74.6 5.9a2.3 2.3 0 00-3.2-3.2L25.7 48.4c-1 .9-1 2.3 0 3.2l45.7 45.7a2.3 2.3 0 003.2-3.2L30.6 50l44-44.1z'
      })
    }
  })()
}
